import React, { useState } from "react";
import ChatIA from "./ChatIA";
import { FaComments } from "react-icons/fa";

const ChatBubble = ({ businessId }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {open && (
        <div style={{ position: "fixed", bottom: "80px", right: "20px", zIndex: 1000 }}>
          <ChatIA businessId={businessId} />
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          fontSize: "24px",
          cursor: "pointer",
          zIndex: 1001
        }}
      >
        <FaComments />
      </button>
    </>
  );
};

export default ChatBubble;
